import { Component, Inject, PLATFORM_ID, HostListener } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CountdownTimerComponent } from '../platinum-page/countdown-timer/countdown-timer.component';

@Component({
    selector: 'app-sticky-cta-banner',
    standalone: true,
    imports: [CommonModule, CountdownTimerComponent, RouterLink],
    templateUrl: './sticky-cta-banner.component.html',
    styleUrls: ['./sticky-cta-banner.component.scss']
})
export class StickyCtaBannerComponent {
    public isVisible = false;
    private isBrowser!: boolean;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    @HostListener('window:scroll')
    onWindowScroll(): void {
        if (this.isBrowser) {
            const scrollThreshold = window.innerHeight;
            this.isVisible = window.scrollY > scrollThreshold;
        }
    }
}
